import router from '@router';

$(() => {
    router.init();
});
